import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/index';
import StorageService from '@/services/storage.service';

// page
import Index from '../views/pages/index/index.vue'
import Homepage from '../views/pages/homepage/index.vue'
// Who We Are
import Journey from '../views/pages/journey/index.vue'
import Vision from '../views/pages/vision/index.vue'
import Principles from '../views/pages/principles/index.vue'
import Founders from '../views/pages/founders/index.vue'
import Milestones from '../views/pages/milestones/index.vue'
// Inside EP Group
import Operations from '../views/pages/operations/index.vue'
import Testimonial from '../views/pages/testimonial/index.vue'
import Strategy from '../views/pages/strategy/index.vue'
// Social Responsibility
import Community from '../views/pages/community/index.vue'
import Work from '../views/pages/work/index.vue'
import Factory from '../views/pages/factory/index.vue'
import Sustainability from '../views/pages/sustainability/index.vue'
import Chairman from '../views/pages/chairman/index.vue'
// join us
import Faq from '../views/pages/faq/index.vue'
import Vacancies from '../views/pages/vacancies/index.vue'
// Gallery
import Gallery from '../views/pages/gallery/index.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: {
        name: 'Homepage',
      },
    },
    {
      path: '/index',
      name: 'Index',
      component: Index,
      beforeEnter: (to, from, next) => {
        // 路由独享
        console.log('init Page: ', to.name);
        const lang = StorageService.getCurLang();
        const index = StorageService.getCurIndex();
        if (lang && index !== null) {
            store.commit("setLanguage", lang);
            store.commit("setLangIndex", index);
            var found = false;
            if (typeof(window.navigator.languages) === 'object') {
                for (var i in window.navigator.languages) {
                    console.log(window.navigator.languages[i].toLowerCase());
                    var l = window.navigator.languages[i].toLowerCase();
                    if(l === 'zh-cn'){
                        found = true;
                        break;
                    }
                  }
            }
            if(!found){
                 store.commit("setLanguage", "EN");
                 store.commit("setLangIndex", 0);
            }
          //console.log('language: ', lang);
          //console.log('index: ', index);
        } else {
          StorageService.clear();
        }
        next();
      },
      children: [
        {
          path: '/homepage',
          name: 'Homepage',
          component: Homepage,
          meta: {
            type: 'Homepage',
          }
        },
        {
          path: '/journey',
          name: 'Journey',
          component: Journey,
          meta: {
            type: 'Whoweare',
          }
        },
        {
          path: '/vision',
          name: 'Vision',
          component: Vision,
          meta: {
            type: 'Whoweare',
          }
        },
        {
          path: '/principles',
          name: 'Principles',
          component: Principles,
          meta: {
            type: 'Whoweare',
          }
        },
        {
          path: '/founders',
          name: 'Founders',
          component: Founders,
          meta: {
            type: 'Whoweare',
          }
        },
        {
          path: '/milestones',
          name: 'Milestones',
          component: Milestones,
          meta: {
            type: 'Whoweare',
          }
        },
        {
          path: '/operations',
          name: 'Operations',
          component: Operations,
          meta: {
            type: 'EPgroup',
          }
        },
        {
          path: '/testimonial',
          name: 'Testimonial',
          component: Testimonial,
          meta: {
            type: 'EPgroup',
          }
        },
        {
          path: '/strategy',
          name: 'Strategy',
          component: Strategy,
          meta: {
            type: 'EPgroup',
          }
        },
        {
          path: '/community',
          name: 'Community',
          component: Community,
          meta: {
            type: 'Responsibility',
          }
        },
        {
          path: '/work',
          name: 'Work',
          component: Work,
          meta: {
            type: 'Responsibility',
          }
        },
        {
          path: '/factory',
          name: 'Factory',
          component: Factory,
          meta: {
            type: 'Responsibility',
          }
        },
        {
          path: '/sustainability',
          name: 'Sustainability',
          component: Sustainability,
          meta: {
            type: 'Responsibility',
          }
        },
        {
          path: '/chairman',
          name: 'Chairman',
          component: Chairman,
          meta: {
            type: 'Responsibility',
          }
        },
        {
          path: '/faq',
          name: 'Faq',
          component: Faq,
          meta: {
            type: 'Joinus',
          }
        },
        {
          path: '/vacancies',
          name: 'Vacancies',
          component: Vacancies,
          meta: {
            type: 'Joinus',
          }
        },
        {
          path: '/gallery/:factoryName',
          name: 'Gallery',
          component: Gallery,
          meta: {
            type: 'Gallery',
          }
        },
      ]
    },
  ]
});

// 路由拦截
router.beforeEach((to, form, next) => {
  // console.log(to.meta.type);
  store.commit("setCurrentPath", to.name);
  store.commit("setActiveName", to.meta.type);
  next();
});

export default router;
